class Polyfills {
    async init() {
        if (typeof window.IntersectionObserver === 'undefined') {
            await import('intersection-observer');
        }
    }
}

export default (() => new Polyfills())();
